/**
 * BetaSection - 베타 참여 안내 섹션
 *
 * 베타 서비스 무료 이용 안내 및 CTA
 * - 베타 기간 무료 강조
 * - 회원가입 유도
 * - 추후 월정액 전환 안내
 */

import React from 'react';
import { Typography, Button, Card, Row, Col } from 'antd';
import { GiftOutlined, RocketOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

export const BetaSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '80px 24px',
      }}
    >
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <Card
          bordered={false}
          style={{
            borderRadius: '24px',
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          }}
          bodyStyle={{ padding: '48px 32px' }}
        >
          {/* 베타 뱃지 */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              padding: '8px 20px',
              borderRadius: '20px',
              marginBottom: '24px',
            }}
          >
            <GiftOutlined style={{ fontSize: '18px' }} />
            <Text strong style={{ color: '#fff', fontSize: '14px' }}>
              BETA 특별 혜택
            </Text>
          </div>

          {/* 메인 메시지 */}
          <Title
            level={2}
            style={{
              marginBottom: '16px',
              fontSize: 'clamp(24px, 4vw, 32px)',
            }}
          >
            지금 가입하면
            <br />
            <span style={{ color: '#667eea' }}>완전 무료</span>로 이용
          </Title>

          <Text
            type="secondary"
            style={{
              fontSize: '16px',
              display: 'block',
              marginBottom: '32px',
              lineHeight: 1.7,
            }}
          >
            베타 기간 동안 모든 기능을 무료로 체험하세요.
            <br />
            정식 출시 후 합리적인 월정액 서비스로 전환됩니다.
          </Text>

          {/* 혜택 요약 */}
          <Row gutter={[16, 16]} style={{ marginBottom: '32px' }}>
            <Col xs={24} sm={8}>
              <div
                style={{
                  padding: '16px',
                  background: '#f8f9ff',
                  borderRadius: '12px',
                }}
              >
                <Text strong style={{ fontSize: '15px', display: 'block' }}>
                  무제한 문제집
                </Text>
                <Text type="secondary" style={{ fontSize: '13px' }}>
                  등록된 모든 문제집 사용
                </Text>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div
                style={{
                  padding: '16px',
                  background: '#f8f9ff',
                  borderRadius: '12px',
                }}
              >
                <Text strong style={{ fontSize: '15px', display: 'block' }}>
                  무제한 학생
                </Text>
                <Text type="secondary" style={{ fontSize: '13px' }}>
                  학생 수 제한 없음
                </Text>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div
                style={{
                  padding: '16px',
                  background: '#f8f9ff',
                  borderRadius: '12px',
                }}
              >
                <Text strong style={{ fontSize: '15px', display: 'block' }}>
                  무제한 채점
                </Text>
                <Text type="secondary" style={{ fontSize: '13px' }}>
                  채점 횟수 제한 없음
                </Text>
              </div>
            </Col>
          </Row>

          {/* CTA 버튼 */}
          <Button
            type="primary"
            size="large"
            icon={<RocketOutlined />}
            onClick={() => navigate('/signup')}
            style={{
              height: '56px',
              padding: '0 48px',
              fontSize: '18px',
              fontWeight: 600,
              borderRadius: '28px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)',
            }}
          >
            무료로 시작하기
          </Button>

          <Text
            type="secondary"
            style={{
              fontSize: '13px',
              display: 'block',
              marginTop: '16px',
            }}
          >
            신용카드 정보 필요 없음 • 가입 즉시 이용 가능
          </Text>
        </Card>
      </div>
    </section>
  );
};
